import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from '../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from '../Automations/useAutomationApiPerType';
import { automationsSortOptions } from '../Automations/consts';
import { selectScheduledReports } from '../../reducers/global/scheduledReportReducers';
import { AutomationScheduledReportsContextProvider } from './AutomationScheduledReportsContextProvider';

const ScheduledReports = ({ disableCanvasTemplates }: { disableCanvasTemplates?: boolean }) => {
  const automationsVariant = AutomationFormVariant.SCHEDULED_REPORTS;
  const scheduledReports = useSelector(selectScheduledReports);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: automationsVariant });
  if (!scheduledReports) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationScheduledReportsContextProvider>
          <AutomationDialogContent
            automations={scheduledReports ?? []}
            onDeleteAutomation={onDeleteAutomation}
            crmOrgId={crmOrg.id}
            onSaveOrCreate={onSaveOrCreate}
            onToggleActivation={onToggleActivation}
            sortOptions={automationsSortOptions}
            disableCanvasTemplates={disableCanvasTemplates}
            onDeployAutomation={onDeployAutomation}
            filters={{}} //filters don't exist also in "canvas view"
          />
        </AutomationScheduledReportsContextProvider>
      )}
    </>
  );
};

export default ScheduledReports;
